export default "__VITE_ASSET__8a_5qdm3__"